var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { justify: "center", align: "center" } },
        [
          _c(
            "v-col",
            { attrs: { lg: "4", xs: "12", sm: "8" } },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    color: _vm.$vuetify.theme.dark
                      ? "#2E2E2E"
                      : "grey lighten-3",
                  },
                },
                [
                  _c(
                    "v-overlay",
                    { attrs: { value: !_vm.serverRunning, absolute: true } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", size: "64" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-overlay",
                    { attrs: { value: _vm.loaderOverlay, absolute: true } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", size: "64" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        {
                          attrs: {
                            justfiy: "center",
                            align: "center",
                            "no-gutters": "",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              class: _vm.isMobile
                                ? "bigFontTime"
                                : "smallFontTime",
                              attrs: {
                                cols: "12",
                                justfiy: "center",
                                "font-weight-regular": "",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: "unselectable " + _vm.CssFontTime,
                                  style: {
                                    color: +_vm.$vuetify.theme.dark
                                      ? "white"
                                      : "",
                                  },
                                  attrs: { align: "center", color: "white" },
                                },
                                [_vm._v(" " + _vm._s(_vm.timeTXT) + " ")]
                              ),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                justfiy: "center",
                                "font-weight-regular": "",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: "unselectable " + _vm.CssFontSize,
                                  style: {
                                    color: +_vm.$vuetify.theme.dark
                                      ? "white"
                                      : "",
                                  },
                                  attrs: { align: "center" },
                                },
                                [_vm._v(" " + _vm._s(_vm.dateTXT) + " ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                ref: "name",
                                attrs: {
                                  "prepend-icon": "mdi-account",
                                  label: _vm.usernameText + ":",
                                  "ma-0": "",
                                  "pa-0": "",
                                  required: "",
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.login()
                                  },
                                },
                                nativeOn: {
                                  keypress: function ($event) {
                                    return _vm.filter.apply(null, arguments)
                                  },
                                },
                                model: {
                                  value: _vm.editedItem.username,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editedItem, "username", $$v)
                                  },
                                  expression: "editedItem.username",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                ref: "address",
                                attrs: {
                                  "append-icon": _vm.showPass
                                    ? "mdi-eye"
                                    : "mdi-eye-off",
                                  "prepend-icon": "mdi-lock",
                                  label: _vm.passwordText + ":",
                                  type: _vm.showPass ? "text" : "password",
                                  rules: [_vm.rules.required],
                                  "ma-0": "",
                                  "pa-0": "",
                                  required: "",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.showPass = !_vm.showPass
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.login()
                                  },
                                },
                                model: {
                                  value: _vm.editedItem.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editedItem, "password", $$v)
                                  },
                                  expression: "editedItem.password",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "mb-3" }),
                      _c(
                        "v-row",
                        {
                          attrs: {
                            "no-gutters": "",
                            "align-content": "center",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6", ms: "6" } },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    "no-gutters": "",
                                    justify: "center",
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      directives: [
                                        {
                                          name: "tap",
                                          rawName: "v-tap",
                                          value: (e) => _vm.login(),
                                          expression: "(e) => login()",
                                        },
                                      ],
                                      class: _vm.$vuetify.theme.dark
                                        ? "white"
                                        : "textColor--text",
                                      attrs: {
                                        color: "primary",
                                        "min-width": _vm.buttonWidth,
                                      },
                                    },
                                    [_vm._v("Login")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6", ms: "6" } },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    "no-gutters": "",
                                    justify: "center",
                                  },
                                },
                                [
                                  _vm.dpBtnPin
                                    ? _c(
                                        "v-btn",
                                        {
                                          class: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "textColor--text",
                                          attrs: {
                                            color: "primary",
                                            "min-width": _vm.buttonWidth,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.dialogPin = !_vm.dialogPin
                                            },
                                          },
                                        },
                                        [_vm._v("Pin")]
                                      )
                                    : _vm._e(),
                                  _vm.dpBtnRFID
                                    ? _c(
                                        "v-btn",
                                        {
                                          class: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "textColor--text",
                                          attrs: {
                                            color: "primary",
                                            "min-width": _vm.buttonWidth,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.dialogRFID = !_vm.dialogRFID
                                            },
                                          },
                                        },
                                        [_vm._v("RFID")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogPin
        ? _c("PinPad", {
            attrs: {
              PersistentDialog: false,
              dateText: _vm.dateTXT,
              timeText: _vm.timeTXT,
            },
            on: {
              close: function ($event) {
                _vm.dialogPin = false
              },
              success: _vm.showWelcomeDialog,
            },
          })
        : _vm._e(),
      _vm.welcomeDialog
        ? _c("Welcomedialog", {
            attrs: {
              name: _vm.$store.getters["user/user"].Name,
              pic: _vm.userPicture,
            },
          })
        : _vm._e(),
      _vm.dialogRFID
        ? _c("RFIDLogin", {
            attrs: {
              dateText: _vm.dateTXT,
              timeText: _vm.timeTXT,
              saveMode: false,
            },
            on: {
              success: _vm.showWelcomeDialog,
              close: function ($event) {
                _vm.dialogRFID = false
              },
            },
          })
        : _vm._e(),
      _vm.dialogPasswordChange
        ? _c("ResetPassword", {
            attrs: {
              "hidden-sm-and-up": "",
              cssfontsize: _vm.CssFontTime,
              newpasswordonlogin: false,
              empid: _vm.userToEdit.SAPEmpID,
            },
            on: { finished: _vm.showWelcomeDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }